import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { useLogger } from "logging";

import usePortalType from "./usePortalType";

const useTrackFAQ = () => {
  const location = useLocation();
  const logger = useLogger();
  const portalType = usePortalType();
  const { user } = useSelector((state) => state.user);
  const [hasViewedFAQ, setHasViewedFAQ] = useState(false);

  return (title) => {
    if (!hasViewedFAQ) {
      logger.trackEvent("FAQ", {
        path: location?.pathname ?? "",
        portal: portalType ?? "",
        roleName: user?.role?.roleName ?? "",
        title: title ?? "",
        userName: user?.userName ?? "",
      });
      setHasViewedFAQ(true);
    }
  };
};

export default useTrackFAQ;
